import React, { useState } from 'react';
import Tesseract from 'tesseract.js';

const ReceiptScanner = () => {
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setText('');
      setError('');
    }
  };

  const processImage = () => {
    if (!image) {
      setError('Please upload an image first.');
      return;
    }

    setIsProcessing(true);
    setError('');
    Tesseract.recognize(image, 'eng', {
      logger: (info) => console.log(info),
    })
      .then(({ data: { text } }) => {
        setText(text);
      })
      .catch((err) => {
        setError('Failed to process the image. Please try again.');
        console.error(err);
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Receipt Scanner</h2>
      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        className="mb-4"
      />
      {image && (
        <div className="mb-4">
          <img
            src={image}
            alt="Uploaded receipt"
            className="max-w-full h-auto rounded-lg"
          />
        </div>
      )}
      <button
        onClick={processImage}
        disabled={isProcessing}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg"
      >
        {isProcessing ? 'Processing...' : 'Scan Receipt'}
      </button>
      {text && (
        <div className="mt-4 p-4 bg-gray-100 rounded-lg">
          <h3 className="font-semibold mb-2">Extracted Text:</h3>
          <p className="whitespace-pre-wrap">{text}</p>
        </div>
      )}
      {error && (
        <div className="mt-4 p-4 bg-red-100 text-red-600 rounded-lg">
          {error}
        </div>
      )}
    </div>
  );
};

export default ReceiptScanner;
